var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M362.7,298.7c0,11.8-9.6,21.3-21.3,21.3H170.7c-11.8,0-21.3-9.6-21.3-21.3c0-11.8,9.6-21.3,21.3-21.3h170.7 C353.1,277.3,362.7,286.9,362.7,298.7z M277.3,362.7H170.7c-11.8,0-21.3,9.6-21.3,21.3c0,11.8,9.6,21.3,21.3,21.3h106.7 c11.8,0,21.3-9.6,21.3-21.3C298.7,372.2,289.1,362.7,277.3,362.7z M469.3,223.7v181.7c-0.1,58.9-47.8,106.6-106.7,106.7H149.3 c-58.9-0.1-106.6-47.8-106.7-106.7V106.7C42.7,47.8,90.5,0.1,149.3,0h96.3c39.6-0.1,77.6,15.6,105.6,43.7l74.3,74.4 C453.7,146,469.4,184.1,469.3,223.7z M321.1,73.9c-6.7-6.5-14.3-12.1-22.4-16.6v92.1c0,11.8,9.6,21.3,21.3,21.3h92.1 c-4.5-8.2-10.1-15.7-16.7-22.4L321.1,73.9z M426.7,223.7c0-3.5-0.7-6.9-1-10.3H320c-35.3,0-64-28.7-64-64V43.7 c-3.5-0.3-6.8-1-10.3-1h-96.3c-35.3,0-64,28.7-64,64v298.7c0,35.3,28.7,64,64,64h213.3c35.3,0,64-28.7,64-64V223.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.42ea6007f94bc37d70d026ab83dd3d10.svg";
export { ForwardRef as ReactComponent };